import { useCallback } from 'react';

import useRequestJSON from './hooks/useRequestJSON';
import { PostJSON, BaseResponse } from './request';
import { AppKey } from './apps';

interface SettingsResponse {
  settings?: any;
}

interface SettingsParams {
  appKey: AppKey;
  patientId?: number;
  contactId?: number;
  programId?: number;
  isEnabled?: boolean;
}

export const useGetSettings = (params: SettingsParams): SettingsResponse => {
  const url = '/settings/edit/';
  const { appKey, patientId, contactId, programId, isEnabled } = params;
  const request = useCallback(
    () =>
      PostJSON({
        url: url,
        params: {
          app: appKey,
          patient: patientId,
          contact: contactId,
          program: programId || null
        }
      }),
    [appKey, patientId, contactId]
  );
  const { data } = useRequestJSON<
    SettingsResponse & BaseResponse,
    SettingsResponse
  >({
    request,
    enabled: isEnabled
  });
  return {
    settings: data?.settings
  };
};
